import React, {ChangeEvent, useRef, useState } from 'react';
import { Checkbox, Grid, Label, Modal, TextArea, Variants } from "@sede-enterprise/shell-ds-react-framework";
import { AnchorSpan } from "../styledComponent/StyledComponent";

import './styles.css';


const TransactionActionModal = (props:any) => {
    
    const [reason, setReason] = useState<string>('');
    const [isChecked, setIsChecked] = useState(false);
    const hiddenFileInput = useRef<HTMLInputElement>(null);

    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const maxFileSizeInBytes = 5242880;

    const submit = () => {
        const formData = new FormData();
        formData.append("file", selectedFiles[0]);
        formData.append("reason", reason);
        props.onSubmit(formData);
    }

    const handleOnChange = () => {
        setIsChecked(!isChecked);
    }

    const handleTextChange = (e: ChangeEvent<HTMLTextAreaElement>) =>{
        setReason(e.target.value);
    }

    const attachmentClick = () =>{
        hiddenFileInput.current?.click();
    }


    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(e.target.files){
            const fileList : FileList = e.target.files;
            const filesArray = Array.from(fileList);
            
            // Validate file types
            const invalidFiles = filesArray.filter(
                (file) =>
                !['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
                'application/vnd.ms-outlook',
                'application/vnd.ms-excel',
                'application/pdf',
                'image/jpeg'].includes(
                    file.type
                )
            );
        
            if (invalidFiles.length > 0) {
                alert('Invalid file type. Please select valid files.');
                return;
            }

            const oversizedFiles = filesArray.filter(file => file.size > maxFileSizeInBytes);

            if (oversizedFiles.length > 0) {
                alert(`File size should be less than 1 MB. Please select valid files.`);
                return;
            }
            setSelectedFiles(filesArray);
        }
    };

    const handleCancel = () => {
        // Clear selected files
        setSelectedFiles([]);
    };


      
    return (
        <>
        {/* Modal Popup for Cancel Transaction */}
            <Modal  open={props.open} onClose={() => {
                    props.onClose();
                }} actions={[{
                label: 'Cancel',
                action: () => {
                    props.onClose();
                },
                props: {
                    variant: Variants.Outlined
                }
                }, {
                label: 'Submit',
                action: () => {
                    submit();
                },
                props: {
                    disabled: (isChecked && reason) ? false : true
                }
                }]}
                title={props.title}
                description= <span className="description">Ticket # {props.description}</span>
                
                >
                <Grid gap='0%'>
                <Label bold>Please specify reason *</Label>
                <TextArea maxLength={300} placeholder="Reason" value={reason} onChange={ (event)=>{handleTextChange(event)}}/>
                <span className="light-text"> Maximum 300 characters are allowed</span>

                </Grid>

                {selectedFiles.length > 0 && (<div>
                        <Label bold>Selected File:</Label>
                        <ul>
                            {selectedFiles.map((file, index) => (
                            <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                        <button onClick={handleCancel}>Remove</button>
                    </div>)
                }
                <AnchorSpan onClick={()=>{attachmentClick()}}><img src="/attachment.svg" alt="Attachment image" style={{top:'8px', position: 'relative'}}/>Attach File</AnchorSpan>  (Optional)
                <div style={{color:'#757575'}}> Maximum allowed file size is 5MB (.jpg, .pdf,. .xls)</div>
                <input
                    type="file"
                    ref={hiddenFileInput}
                    onChange={(e)=>{handleFileUpload(e)}}
                    style={{display:'none'}}
                />
                
                <Checkbox checked={isChecked} onChange={handleOnChange} label="Confirm the information entered is checked and correct. *"/>
            </Modal>
        </>
    )
}

export default TransactionActionModal;